<template>
  <a-modal
    width="600px"
    title="拆分任务"
    v-model:visible="visible"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="spinning" tip="任务拆分中……">
    <a-form
      class="detail-form"
      ref="form"
      :model="form"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }">
      <a-form-item label="任务名称">
        {{ form.name }}
      </a-form-item>
      <a-form-item label="任务总量">
        {{ form.total }}
      </a-form-item>
      <a-form-item label="单批次任务量">
        <a-input-number
          v-model:value="form.chunk"
          :min="1"
          :max="form.total"
          :step="1"
          :precition="0"
          @change="showTaskNumber = Math.ceil(form.total / form.chunk); form.subCount = Math.floor(form.total / form.chunk)" />
      </a-form-item>
      <a-form-item label="子任务数">
        {{ showTaskNumber }}
      </a-form-item>
    </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
// import { getDataByPage } from '@/api/dataItem'
import { getSplitTask, getResetTask } from '@/api/task'
import { getDatasetItem } from '@/api/dataSet'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      visible: false,
      form: {
        name: '',
        total: 2000,
        chunk: 200,
        subCount: 10
      },
      page: {
        pageNum: 1,
        pageSize: 10
      },
      showTaskNumber: '',
      spinning: false
    }
  },
  methods: {
    open () {
      this.visible = true
      this.$nextTick(() => {
        this.getDataItems(1)
      })
    },
    getDataItems (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      // const addition = this.addition
      getDatasetItem({
        datasetId: this.currentItem.datasetId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }).then(res => {
        // const params = Object.fromEntries(addition.split('&').map(str => str.split('=')))
        this.form.name = this.currentItem.name
        this.form.total = res.total
        this.form.chunk = this.form.total ? this.form.total : 2000
        this.form.subCount = Math.floor(this.form.total / this.form.chunk)
        this.showTaskNumber = Math.ceil(this.form.total / this.form.chunk)
      })
    /*  getDataByPage({ ...this.page, ...params }).then(res => {
        const data = res.data.map.data
        this.form.name = this.currentItem.name
        this.form.total = data.total ? data.total : 2000
        this.form.chunk = this.form.total ? this.form.total : 2000
        this.form.subCount = Math.floor(this.form.total / this.form.chunk)
        this.showTaskNumber = Math.ceil(this.form.total / this.form.chunk)
      }) */
    },
    handleSubmit () {
      this.spinning = true
      const self = this
      if (self.currentItem.reset) {
        getResetTask({ id: self.currentItem.id }).then(res => {
          if (res.data.state === 'success') {
            setTimeout(function () {
              getSplitTask({
                singleNumber: self.form.chunk, id: self.currentItem.id, state: 'waiting_assign', linkState: 'waiting_assign'
              }).then(res => {
                self.spinning = false
                if (res.data.state !== 'success') {
                  // this.$message.error(res.data.description)
                  self.$message.warning(res.data.description)
                  self.$emit('refresh-data')
                } else {
                  self.$message.success('任务正在拆分……')
                  setTimeout(function () {
                    self.$emit('refresh-data')
                  }, 2000)
                }
                self.visible = false
              })
            }, 2000)
          }
        })
      } else {
        getSplitTask({
          singleNumber: self.form.chunk, id: self.currentItem.id, state: 'waiting_assign', linkState: 'waiting_assign'
        }).then(res => {
          self.spinning = false
          if (res.data.state !== 'success') {
            // this.$message.error(res.data.description)
            self.$message.warning(res.data.description)
            self.$emit('refresh-data')
          } else {
            self.$message.success('任务正在拆分……')
            setTimeout(function () {
              self.$emit('refresh-data')
            }, 2000)
          }
          self.visible = false
        })
      }
    },
    handleCancel () {
      // this.$emit('refresh-data')
      this.visible = false
    }
  }
}
</script>
<style lang="less">

</style>
